import React, { PropsWithChildren } from "react";
import ReactDOM from "react-dom";
import { ModalProps } from "./interface";
import styles from "./Modal.module.scss";
/***************************
 * Modal
 ***************************/
export default function Modal({
  children,
  openModal,
}: PropsWithChildren<ModalProps>) {
  if (!openModal) return null;
  return ReactDOM.createPortal(
    <>
      {" "}
      <div className={styles.modal_background} />
      <div className={styles.modal_style_down}>{children}</div>
    </>,
    document.getElementById("portal") as HTMLElement,
  );
}
